import React from 'react'

import Svg, { Path } from 'react-native-svg'

const PDF = ({ ...props }) => {
  return (
    <Svg
      width={62}
      height={62}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M17.5 4a3.385 3.385 0 0 0-3.375 3.375v47.25A3.385 3.385 0 0 0 17.5 58h33.75a3.385 3.385 0 0 0 3.375-3.375V17.5L41.125 4H17.5Z"
        fill="#fff"
      />
      <Path
        d="M44.5 17.5h10.125L41.125 4v10.125A3.385 3.385 0 0 0 44.5 17.5Z"
        fill="#C1CCD5"
      />
      <Path d="M54.625 27.625 44.5 17.5h10.125v10.125Z" fill="#EDF3FA" />
      <Path
        d="M47.875 47.875c0 .928-.76 1.688-1.688 1.688H9.063c-.929 0-1.688-.76-1.688-1.688V31c0-.928.76-1.688 1.688-1.688h37.124c.929 0 1.688.76 1.688 1.688v16.875Z"
        fill="#F15642"
      />
      <Path
        d="M14.73 35.973c0-.445.352-.931.917-.931h3.117c1.755 0 3.334 1.174 3.334 3.425 0 2.133-1.58 3.321-3.334 3.321H16.51v1.782c0 .594-.378.93-.864.93a.91.91 0 0 1-.916-.93v-7.597Zm1.781.768v3.361h2.253c.904 0 1.62-.798 1.62-1.635 0-.943-.716-1.726-1.62-1.726H16.51ZM24.741 44.5c-.445 0-.931-.243-.931-.835V36c0-.484.486-.837.931-.837h3.09c6.166 0 6.031 9.337.121 9.337h-3.21Zm.85-7.69v6.045h2.24c3.643 0 3.805-6.045 0-6.045h-2.24ZM36.049 36.918v2.145h3.44c.487 0 .973.486.973.957 0 .445-.486.81-.972.81h-3.441v2.833c0 .472-.336.835-.809.835-.593 0-.956-.363-.956-.835v-7.665c0-.484.364-.837.956-.837h4.737c.594 0 .945.353.945.837a.932.932 0 0 1-.945.918H36.05v.002Z"
        fill="#fff"
      />
      <Path
        d="M46.188 49.563H14.124v1.687h32.063c.928 0 1.687-.76 1.687-1.688v-1.687c0 .928-.76 1.688-1.688 1.688Z"
        fill="#CAD1D8"
      />
    </Svg>
  )
}

export default PDF
